/* Vasudha Alankara – photo slideshows (product cards + home banner).
   Each photo stays about 2 seconds, then slowly fades away while the next one blooms in. */
(function () {
  var HOLD = 2000, FADE = 1500, INTERVAL = HOLD + FADE;
  var css = document.createElement('style');
  css.textContent =
    /* product cards: stack the photos and cross-fade */
    '.card-gallery slideshow-slides.va-run{display:grid!important;overflow:hidden!important;scroll-snap-type:none!important}' +
    '.card-gallery slideshow-slides.va-run>slideshow-slide{grid-area:1/1;content-visibility:visible!important;opacity:0;transform:scale(.96);transition:opacity ' + FADE + 'ms ease-in-out,transform ' + (FADE + 600) + 'ms ease-out}' +
    '.card-gallery slideshow-slides.va-run>slideshow-slide.va-on{opacity:1;transform:scale(1);z-index:1}' +
    '.card-gallery slideshow-slides.va-run>slideshow-slide.va-off{opacity:0;transform:scale(1.03)}' +
    /* home banner */
    '.hero__media-grid.va-has-slides>picture,.hero__media-grid.va-has-slides>.hero__media-wrapper,.hero__media-grid.va-has-slides>img{visibility:hidden}' +
    '.va-hero-slides{position:absolute;inset:0;overflow:hidden;background:#1E1A16}' +
    '.va-hero-slide{position:absolute;inset:0;opacity:0;transition:opacity ' + FADE + 'ms ease-in-out}' +
    '.va-hero-slide.on{opacity:1;z-index:1}' +
    '.va-hero-slide .bg{position:absolute;inset:-40px;width:calc(100% + 80px);height:calc(100% + 80px);object-fit:cover;filter:blur(28px) brightness(.55)}' +
    '.va-hero-slide .fg{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;object-position:center;transform:scale(.96);transition:transform ' + (FADE + 800) + 'ms ease-out}' +
    '.va-hero-slide.on .fg{transform:scale(1)}' +
    '.va-hero-slide.off .fg{transform:scale(1.04)}' +
    '@media (min-width:750px){.va-hero-slide .fg{object-position:82% center}.hero__container:has(.va-has-slides) .hero__content-wrapper{align-items:flex-start!important;justify-content:center!important;width:52%!important;margin-right:auto!important;padding-left:6vw!important}.hero__container:has(.va-has-slides) .hero__content-wrapper .text-block,.hero__container:has(.va-has-slides) .hero__content-wrapper .text-block *{text-align:left!important;margin-left:0!important}.hero__container:has(.va-has-slides) .hero__content-wrapper>*{align-self:flex-start!important}}' +
    '@media (max-width:749px){.va-hero-slide .fg{object-fit:cover;object-position:center 22%}.va-hero-slide .bg{display:none}}' +
    '@media (prefers-reduced-motion:reduce){.va-hero-slide,.va-hero-slide .fg,.card-gallery slideshow-slides.va-run>slideshow-slide{transition:none!important;transform:none!important}}';
  document.head.appendChild(css);

  function step(list, i, onCls, offCls) {
    var n = list.length;
    var next = (i + 1) % n;
    list[i].classList.remove(onCls);
    list[i].classList.add(offCls);
    list[next].classList.remove(offCls);
    list[next].classList.add(onCls);
    var prev = list[i];
    setTimeout(function () { prev.classList.remove(offCls); }, FADE + 900);
    return next;
  }

  var heroSlides = null, heroI = 0;
  function buildHero() {
    var urls = window.vaHeroImages;
    if (!urls || !urls.length) return;
    var grid = document.querySelector('.hero__media-grid');
    if (!grid || grid.querySelector('.va-hero-slides')) return;
    var box = document.createElement('div');
    box.className = 'va-hero-slides';
    box.setAttribute('aria-hidden', 'true');
    urls.forEach(function (u, i) {
      var s = document.createElement('div');
      s.className = 'va-hero-slide' + (i === 0 ? ' on' : '');
      s.innerHTML = '<img class="bg" alt="" src="' + u + '"' + (i ? ' loading="lazy"' : '') + '>' +
        '<img class="fg" alt="" src="' + u + '"' + (i ? '' : ' fetchpriority="high"') + '>';
      box.appendChild(s);
    });
    grid.insertBefore(box, grid.firstChild);
    grid.classList.add('va-has-slides');
    heroSlides = box.children;
  }
  function tickHero() {
    if (!heroSlides || heroSlides.length < 2) return;
    heroI = step(heroSlides, heroI, 'on', 'off');
  }

  function tickCards() {
    document.querySelectorAll('.card-gallery slideshow-slides').forEach(function (sc) {
      var slides = Array.prototype.filter.call(sc.children, function (s) { return !s.hidden; });
      if (slides.length < 2) return;
      if (!sc.classList.contains('va-run')) {
        sc.classList.add('va-run');
        sc.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; });
        slides[0].classList.add('va-on');
        sc.dataset.vaI = '0';
        return;
      }
      var i = parseInt(sc.dataset.vaI || '0', 10) % slides.length;
      sc.dataset.vaI = String(step(slides, i, 'va-on', 'va-off'));
    });
  }
  function start() {
    buildHero();
    tickCards();
    setInterval(function () { tickHero(); tickCards(); }, INTERVAL);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
